'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reselect = require('reselect');

var _configuration = require('../configuration');

var _configuration2 = _interopRequireDefault(_configuration);

var _analytics = require('../analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _session = require('../session');

var _session2 = _interopRequireDefault(_session);

var _language = require('../language');

var _language2 = _interopRequireDefault(_language);

var _sagas = require('../../hocs/sagas');

var _sagas2 = _interopRequireDefault(_sagas);

var _context = require('../../sagas/context');

var _context2 = _interopRequireDefault(_context);

var _reduceLocation = require('../../actions/context/reduceLocation');

var _reduceLocation2 = _interopRequireDefault(_reduceLocation);

var _selectOperation = require('../../selectors/context/selectOperation');

var _reduceOperation = require('../../actions/context/reduceOperation');

var _reduceOperation2 = _interopRequireDefault(_reduceOperation);

var _selectLoading = require('../../selectors/context/selectLoading');

var _reduceLoading = require('../../actions/context/reduceLoading');

var _reduceLoading2 = _interopRequireDefault(_reduceLoading);

var _reduceScriptCache = require('../../actions/context/reduceScriptCache');

var _reduceScriptCache2 = _interopRequireDefault(_reduceScriptCache);

var _selectScriptCache = require('../../selectors/context/selectScriptCache');

var _selectSubfolderPrefix = require('../../selectors/context/selectSubfolderPrefix');

var _selectStorefrontUrl = require('../../selectors/context/selectStorefrontUrl');

var _getStorefrontUrl = require('../../actions/context/getStorefrontUrl');

var _getStorefrontUrl2 = _interopRequireDefault(_getStorefrontUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Context = function (_React$Component) {
	_inherits(Context, _React$Component);

	function Context() {
		_classCallCheck(this, Context);

		return _possibleConstructorReturn(this, (Context.__proto__ || Object.getPrototypeOf(Context)).apply(this, arguments));
	}

	_createClass(Context, [{
		key: 'render',
		value: function render() {
			var context = {
				subfolderPrefix: this.props.subfolderPrefix,
				loading: this.props.loading,
				operation: this.props.operation,
				doReduceLocation: this.props.doReduceLocation,
				doClearOperation: this.props.doClearOperation,
				doReduceLoading: this.props.doReduceLoading,
				doReduceScriptCache: this.props.doReduceScriptCache,
				doRedirectToStorefront: this.props.doRedirectToStorefront,
				doGetStorefrontUrl: this.props.doGetStorefrontUrl,
				scriptCache: this.props.scriptCache,
				storefrontUrl: this.props.storefrontUrl,
				offline: this.props.offline
			};
			return _react2.default.createElement(
				_configuration2.default,
				{ context: context },
				_react2.default.createElement(
					_session2.default,
					null,
					_react2.default.createElement(
						_analytics2.default,
						null,
						_react2.default.createElement(
							_language2.default,
							{ messages: this.props.messages,
								overrideCulture: this.props.overrideCulture
							},
							this.props.children
						)
					)
				)
			);
		}
	}]);

	return Context;
}(_react2.default.Component);

var mapStateToProps = (0, _reselect.createStructuredSelector)({
	operation: (0, _selectOperation.selectOperation)(),
	loading: (0, _selectLoading.selectLoading)(),
	scriptCache: (0, _selectScriptCache.selectScriptCache)(),
	subfolderPrefix: (0, _selectSubfolderPrefix.selectSubfolderPrefix)(),
	storefrontUrl: (0, _selectStorefrontUrl.selectStorefrontUrl)()
});

function mapDispatchToProps(dispatch) {
	return {
		doReduceLocation: function doReduceLocation(payload) {
			return dispatch((0, _reduceLocation2.default)(payload));
		},
		doClearOperation: function doClearOperation() {
			return dispatch((0, _reduceOperation2.default)(null));
		},
		doReduceLoading: function doReduceLoading(payload) {
			return dispatch((0, _reduceLoading2.default)(payload));
		},
		doReduceScriptCache: function doReduceScriptCache(payload) {
			return dispatch((0, _reduceScriptCache2.default)(payload));
		},
		doGetStorefrontUrl: function doGetStorefrontUrl() {
			return dispatch((0, _getStorefrontUrl2.default)());
		}
	};
}

var withConnect = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps);

var withSaga = (0, _sagas2.default)({ key: 'context', saga: _context2.default });

exports.default = (0, _redux.compose)(withConnect, withSaga)(Context);